// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__P3_V5","bg":"Modal_bg__28hHO","fadeIn":"Modal_fadeIn__5-6_P","close":"Modal_close__3rW_Y","ttl":"Modal_ttl__1vM6W","overlay":"Modal_overlay__2GjdW"};